import React from "react";
import { FAQS } from "../data/cruiseData";
import SEOHead from "../components/SEOHead";

export default function FAQ() {
 return (
 <main className="pt-32 pb-24" data-testid="faq-page">
 <SEOHead
  title="Sydney Harbour Cruise FAQ | Magic Cruises Booking & Charter Questions"
  description="Answers to every Sydney Harbour cruise question , capacity, pricing, catering, beverage packages, weather policy, deposits, BYO rules, boarding times and more for MV Sydney Magic."
  image="https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/srsraacs_sydney%20cruises%20boats.png"
  canonical="/faq"
  keywords="Sydney Harbour cruise FAQ, Magic Cruises questions, boat hire Sydney FAQ, charter booking questions"
  faqItems={FAQS}
  breadcrumbs={[
   { name: "Home", url: "/" },
   { name: "FAQ", url: "/faq" },
  ]}
 />
 <div className="mx-auto max-w-3xl px-5 lg:px-10">
 <div className="eyebrow">FAQs</div>
 <h1 className="font-display text-4xl lg:text-7xl mt-3 mb-10 text-ink leading-[1]">Frequently asked <span className="text-pink italic">questions</span>.</h1>
 <div className="space-y-2">
 {FAQS.map((f, i) => (
 <details key={i} className="bg-white rounded-xl border border-[hsla(222,20%,80%,0.5)] p-5 group" data-testid={`faq-item-${i}`}>
 <summary className="cursor-pointer font-bold text-ink flex justify-between items-center">{f.q}<span className="text-pink group-open:rotate-45 transition-transform text-xl ml-4">+</span></summary>
 <p className="text-ink-soft text-sm mt-3 leading-relaxed">{f.a}</p>
 </details>
 ))}
 </div>
 </div>
 </main>
 );
}
